import "core-js/stable";
import "core-js/features/promise/all-settled";
import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter as Router } from "react-router-dom";
import GlobalConfigContext from '@context/GlobalConfigContext';
import './index.css';
import App from './App';
import * as serviceWorker from './serviceWorker';
import { LanguageService, PwaService} from '@apiService/tokenService';
import { isInStandaloneMode } from '@helper/utils'
import GenericService from '@apiService/GenericService';
import ComingSoonSelector from '@components/ComingSoonSelector';
import { getTrackingIdInfo } from '@helper/googleAnalytics';
import ReactGA from 'react-ga';
import qs from 'qs';
import * as Sentry from "@sentry/react";
import './assets/sentry/sentry';
import { createBrowserHistory } from 'history';

export const history = createBrowserHistory();

const language = LanguageService.getLanguage();

const qparams = qs.parse(window.location.search, { ignoreQueryPrefix: true });
const lang_from_param = qparams.lang;

let isCountryDataLoaded = false;
let isCssFetched = false;

function stopMainSpinner() {
  let mainSpinner = document.getElementById('main-spinner');
  if(mainSpinner) {
    mainSpinner.style.display = "none";
  }
}

if (language == 'ar' || language == 'ab' || lang_from_param == 'ar') {
  import('@assets/css/App.css').finally((condition) => {
    isCssFetched = true;
    if(isCountryDataLoaded) {
      stopMainSpinner()
    }
  })
} else {
  import('@assets/css/App.css').finally((condition) => { 
    isCssFetched = true;
    if(isCountryDataLoaded) {
      stopMainSpinner()
    }
  })
}

const isPwa = isInStandaloneMode();
if(isPwa) {
  PwaService.setIsPwa(true);
}

const SentryApp = Sentry.withErrorBoundary(App, {
  fallback: null, 
  beforeCapture: (scope, error, info) => {
    scope.setTag("errorBoundary", "main");
    scope.setContext("errorInfo", info);
  },
});

GenericService.GetCountrySpecificData()
  .then(response => {
    if(response && response.status === 200) {
      const data = response.data.data; 
      if(data.is_under_maintainance === 'Y') {
        ReactDOM.render(<ComingSoonSelector />, document.getElementById('root'))
      } else {
        ReactDOM.render(
          <GlobalConfigContext>
            <Router>
              <SentryApp />
            </Router>
          </GlobalConfigContext>,
          document.getElementById('root')
        );
      }
    }
  })
  .catch(err => {
    Sentry.captureException(err, {
      tags: {
        location: "country_data_fetch",
        type: "api_error"
      }
    });
    
    ReactDOM.render(
      <GlobalConfigContext>
        <Router>
          <SentryApp />
        </Router>
      </GlobalConfigContext>,
      document.getElementById('root')
    );
  }).finally(() => {
    isCountryDataLoaded = true;
    if(isCssFetched) {
      stopMainSpinner()
    }
  });

serviceWorker.unregister();